import { render, staticRenderFns } from "./edit-request-action.vue?vue&type=template&id=20a5122c"
import script from "./edit-request-action.vue?vue&type=script&lang=js"
export * from "./edit-request-action.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports